export default "__VITE_ASSET__Drhtq4Na__"